import React from 'react';
import PrivateRoute from './PrivateRoute';
import { getPathApp } from '../utils/util';
import { PERMISSIONS } from '../utils/constants';
import Resource from '../containers/Configuration/Resource/Resource';
import ResourceInsert from '../containers/Configuration/Resource/ResourceInsert';
import ResourceList from '../containers/Configuration/Resource/ResourceList';

import Print from '../containers/Configuration/Print/Print';
import PrintInsert from '../containers/Configuration/Print/PrintInsert';
import PrintList from '../containers/Configuration/Print/PrintList';
import PrintTest from '../containers/Configuration/Print/PrintTest';

import Plant from '../containers/Configuration/Plant/Plant';
import PlantInsert from '../containers/Configuration/Plant/PlantInsert';
import PlantList from '../containers/Configuration/Plant/PlantList';

import Area from '../containers/Configuration/Area/Area';
import AreaInsert from '../containers/Configuration/Area/AreaInsert';
import AreaList from '../containers/Configuration/Area/AreaList';

import Unit from '../containers/Configuration/Unit/Unit';
import UnitInsert from '../containers/Configuration/Unit/UnitInsert';
import UnitList from '../containers/Configuration/Unit/UnitList';

import Justification from '../containers/Configuration/Justification/Justification';
import JustificationInsert from '../containers/Configuration/Justification/JustificationInsert';
import JustificationList from '../containers/Configuration/Justification/JustificationList';

import MovementType from '../containers/Configuration/MovementType/MovementType';
import MovementTypeInsert from '../containers/Configuration/MovementType/MovementTypeInsert';
import MovementTypeList from '../containers/Configuration/MovementType/MovementTypeList';

import Equipment from '../containers/Configuration/Equipment/Equipment';
import EquipmentInsert from '../containers/Configuration/Equipment/EquipmentInsert';
import EquipmentList from '../containers/Configuration/Equipment/EquipmentList';

import User from '../containers/Configuration/User/UserHome';

import Parameterization from '../containers/Configuration/Parameterization/Home/Parameterization';
import ChangeLocation from '../containers/Configuration/Parameterization/ChangeLocation/ChangeLocationHome';
import Inventory from '../containers/Configuration/Parameterization/Inventory/InventoryHome';
import PhysicalConfirmation from '../containers/Configuration/Parameterization/PhysicalConfirmation/PhysicalConfirmationHome';
import Picking from '../containers/Configuration/Parameterization/Picking/PickingHome';
import LinePicking from '../containers/Configuration/Parameterization/LinePicking/LinePickingHome';
import Volume from '../containers/Configuration/Parameterization/Volume/VolumeHome';
import ServiceMonitor from '../containers/Configuration/ServiceMonitor';
import Monitor from '../containers/Configuration/Monitor/monitor';
import Home from '../containers/Configuration/Home/Configuration';

import AreaPdu from '../containers/Configuration/AreaPdu/AreaPdu';

import Token from '../containers/Configuration/Token/Token';
import TokenList from '../containers/Configuration/Token/TokenList';
import TokenDetail from '../containers/Configuration/Token/TokenDetail';
import TokenInsert from '../containers/Configuration/Token/TokenInsert';

import AlternativeMdrPartnumber from '../containers/PhysicalConfirmationV2/AlternativeMdrPartnumber/AlternativeMdrPartnumber';
import AlternativeMdrPartnumberList from '../containers/PhysicalConfirmationV2/AlternativeMdrPartnumber/AlternativeMdrPartnumberList';
import AlternativeMdrPartnumberInsert from '../containers/PhysicalConfirmationV2/AlternativeMdrPartnumber/AlternativeMdrPartnumberInsert';

import QmePartNumber from '../containers/PhysicalConfirmationV2/QmePartNumber/QmePartNumber';
import QmePartNumberList from '../containers/PhysicalConfirmationV2/QmePartNumber/QmePartNumberList';
import QmePartNumberInsert from '../containers/PhysicalConfirmationV2/QmePartNumber/QmePartNumberInsert';
import WarehouseManagement from '../containers/Configuration/Parameterization/WarehouseManagement/WarehouseManagement';
import EmailInsert from '../containers/Configuration/Alerts/EmailInsert';

let aux = 0;
const pathurl = getPathApp(window);
const ConfigurationRoute = [
    <PrivateRoute key={aux += 1} path={`${pathurl}/config/plant/insert`} component={PlantInsert} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/config/plant/list`} component={PlantList} />,

    <PrivateRoute key={aux += 1} path={`${pathurl}/config/area/insert`} component={AreaInsert} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/config/area/list`} component={AreaList} />,

    <PrivateRoute key={aux += 1} path={`${pathurl}/config/unit/insert`} component={UnitInsert} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/config/unit/list`} component={UnitList} />,

    <PrivateRoute key={aux += 1} path={`${pathurl}/config/print/test`} component={PrintTest} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/config/print/insert`} component={PrintInsert} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/config/print/list`} component={PrintList} />,

    <PrivateRoute key={aux += 1} path={`${pathurl}/config/resource/insert`} component={ResourceInsert} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/config/resource/list`} component={ResourceList} />,

    <PrivateRoute key={aux += 1} path={`${pathurl}/config/justification/insert`} component={JustificationInsert} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/config/justification/list`} component={JustificationList} />,

    <PrivateRoute key={aux += 1} path={`${pathurl}/config/equipment/insert`} component={EquipmentInsert} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/config/equipment/list`} component={EquipmentList} />,

    <PrivateRoute key={aux += 1} path={`${pathurl}/config/movementType/insert`} component={MovementTypeInsert} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/config/movementType/list`} component={MovementTypeList} />,


    <PrivateRoute key={aux += 1} path={`${pathurl}/config/token/detail`} component={TokenDetail} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/config/token/list`} component={TokenList} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/config/token/create`} component={TokenInsert} />,


    <PrivateRoute key={aux += 1} path={`${pathurl}/config/params/linepicking`} component={LinePicking} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/config/params/picking`} component={Picking} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/config/params/changeLocation`} component={ChangeLocation} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/config/params/inventory`} component={Inventory} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/config/params/physicalConfirmation`} component={PhysicalConfirmation} validatePermission={PERMISSIONS.PhysicalConfirmation.Config} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/config/params/volume`} component={Volume} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/config/params/warehouseManagement`} component={WarehouseManagement} />,

    <PrivateRoute key={aux += 1} path={`${pathurl}/config/areaPdu`} component={AreaPdu} />,

    <PrivateRoute key={aux += 1} path={`${pathurl}/config/alert/emailInsert`} component={EmailInsert} />,

    <PrivateRoute key={aux += 1} path={`${pathurl}/config/movementType`} component={MovementType} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/config/justification`} component={Justification} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/config/user`} component={User} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/config/print`} component={Print} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/config/equipment`} component={Equipment} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/config/qmePartNumber/home`} component={QmePartNumber} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/config/qmePartNumber/List`} component={QmePartNumberList} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/config/qmePartNumber/Insert`} component={QmePartNumberInsert} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/config/alternativeMdrPartnumber/home`} component={AlternativeMdrPartnumber} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/config/alternativeMdrPartnumber/List`} component={AlternativeMdrPartnumberList} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/config/alternativeMdrPartnumber/Insert`} component={AlternativeMdrPartnumberInsert} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/config/Plant`} component={Plant} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/config/area`} component={Area} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/config/unit`} component={Unit} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/config/resource`} component={Resource} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/config/params`} component={Parameterization} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/config/token`} component={Token} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/config/monitor`} component={Monitor} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/config/serviceMonitor`} component={ServiceMonitor} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/config`} component={Home} />
];

export default ConfigurationRoute;
